import styled from "styled-components";

export type FloatingLabelCalenderStylesProps = {
  isTextHidden?: boolean;
};

const FloatingLabelCalenderStyles = styled.div<FloatingLabelCalenderStylesProps>`
  input {
    cursor: not-allowed;
    color: ${({ isTextHidden }) => (isTextHidden ? "transparent" : "inherit")};
  }

  label {
    margin-bottom: -20px;
    margin-left: 6px;
    /* We need to adjust the margin on the label on a password input */
    border-radius: 6px;
    z-index: 2;
    top: 0px !important;
    font-size: 16px;
    padding: 0px;
    height: 25px;
    padding-left: 5px;
    padding-right: 5px;
    transform: translate(calc(1rem - 5px), calc(70% - (3.75rem / 2)))
      scale(0.95) !important;
  }

  fieldset > div {
    height: 3.8rem;
  }

  #${(props) => props.id}-calendar-picker {
    position: unset;
  }
  .react-datepicker-popper {
    z-index: 20;
  }
`;

export default FloatingLabelCalenderStyles;
